const autoHeight = () => {

  //指定の要素を取得
  // let elem = document.getElementById('item-service');
  //要素をすべて取得
  let elemChildren = document.getElementsByClassName('mod-ttl');
  //高さの最大値を代入する変数を初期化
  let elemMaxHeight = 0;
  //elemの子要素の高さを格納する配列を初期化
  let elemArray = new Array;

  //elemの子要素をループ
  Array.prototype.forEach.call(elemChildren, function(elemChild) {
    
    //子要素の高さのスタイルを初期化（リサイズ対応用）
    elemChild.style.height = '';
    //elemの各子要素の高さを取得
    elemArray.push(elemChild.clientHeight);

  });

  //配列に格納した高さの最大値を取得
  elemMaxHeight = Math.max.apply(null, elemArray);

  //elemの子要素をループ
  Array.prototype.forEach.call(elemChildren, function(elemChild) {
    //elemの子要素のheightにelemMaxHeightを設定
    elemChild.style.height = elemMaxHeight + 'px';

  });
}

//ロードとリサイズ時に関数autoHeightを実行
window.addEventListener('load', autoHeight);
window.addEventListener('resize', autoHeight);